import { useEffect, useMemo, useReducer, useRef, useState } from 'react'
import styles from './index.less'
import classNames from 'classnames'
import ReactDOM from 'react-dom/client'
import closeSvg from '@/assets/icon/close.svg'


export const CouponDialog = ({ open, onClose, imageUrl }: any) => {
  const [isShow, setIsShow] = useState(false)
  const clickClose = () => {
    setIsShow(false)
    onClose?.()
  }
  useEffect(() => {
    if (open) {
      setIsShow(true)
    }
  }, [open])
  return (
    isShow && (
      <div className={classNames(styles.mask, styles.openDialog)}>
        <div className={styles.container}>
          <div className={styles.close} onClick={clickClose}>
            <img src={closeSvg} />
          </div>
          <img onClick={clickClose} className={styles.content} src={imageUrl} alt="" />
        </div>
      </div>
    )
  )
}

export const openCouponDialog = (params: {
  onClose?: Function // 取消回调
  imageUrl?: string
}) => {
  const { onClose, imageUrl, ...rest } = params
  const dom = document.getElementById('CouponDialog')
  dom && dom.parentElement && dom.parentElement.removeChild(dom)
  const container = document.createElement('div')
  // const id = new Date().getTime() + 'exportDialog';
  const id = 'CouponDialog'
  container.setAttribute('id', id)
  document.body.appendChild(container)
  const root = ReactDOM.createRoot(container)

  const cancel = () => {
    root.unmount()
    container && container.parentElement && container.parentElement.removeChild(container)
  }
  window.addEventListener('popstate', function (event) {
    cancel()
  })

  return root.render(
    <CouponDialog
      open={true}
      imageUrl={imageUrl}
      onClose={e => {
        cancel()
        onClose && onClose(e)
      }}
      {...rest}
    />,
  )
}
